import { create } from 'zustand';

type SlideID = 'try-on' | 'search' | 'personalize' | 'curations' | 'brands';

interface DownloadAppSheetState {
  isOpen: boolean;
  initialSlide: SlideID;
  openSheet: (initialSlide: SlideID) => void;
  closeSheet: () => void;
}

const useDownloadAppSheetStore = create<DownloadAppSheetState>((set) => ({
  isOpen: false,
  initialSlide: 'try-on',
  openSheet: (initialSlide) => set({ isOpen: true, initialSlide }),
  closeSheet: () => set({ isOpen: false }),
}));

export default useDownloadAppSheetStore;
